module.exports = __webpack_public_path__ + "static/media/woman.e44b50e6.png";